import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const PartnerSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default PartnerSVG;
